export const MAX_CHECKPOINTS = 120;
export const localDateIso = (date = new Date()) => date.getFullYear() + '-' + String(date.getMonth() + 1).padStart(2, '0') + '-' + String(date.getDate()).padStart(2, '0');
const calendarDayNumber = (iso) => Date.parse(iso + 'T00:00:00Z') / 86400000;
const validDate = (iso) => typeof iso === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(iso)
  && Number.isFinite(calendarDayNumber(iso)) && localDateIso(new Date(iso + 'T12:00:00')) === iso;

// Count actual weekdays, including a selected end day. Calendar-day arithmetic
// keeps the biweekly rhythm stable across daylight-saving changes. Without an
// explicit end date, retain the short four-checkpoint starter plan.
export function checkpointSchedule({ days, biweekly = false, endDate = null, startDate = localDateIso() }) {
  const selected = [...new Set(days || [])].filter((d) => Number.isInteger(d) && d >= 0 && d <= 6);
  if (!validDate(startDate) || (endDate != null && !validDate(endDate))) {
    return { dues: [], error: 'Choose a valid end date.', weeks: 0 };
  }
  if (!selected.length || selected.length > 5 || (biweekly && selected.length !== 1)) {
    return { dues: [], error: 'Choose the weekdays for your checkpoints.', weeks: 0 };
  }
  if (endDate && endDate <= startDate) {
    return { dues: [], error: 'Choose an end date after today.', weeks: 0 };
  }
  const span = endDate ? calendarDayNumber(endDate) - calendarDayNumber(startDate) : 60;
  if (span > 3660) return { dues: [], error: 'Choose an end date within the next 10 years.', weeks: 0 };
  const dues = [];
  let anchorMonday = null;
  for (let offset = 1; offset <= span; offset += 1) {
    const date = new Date(startDate + 'T12:00:00');
    date.setDate(date.getDate() + offset);
    const dow = date.getDay();
    if (!selected.includes(dow)) continue;
    const day = localDateIso(date);
    const monday = calendarDayNumber(day) - ((dow + 6) % 7);
    if (anchorMonday === null) anchorMonday = monday;
    if (biweekly && ((monday - anchorMonday) / 7) % 2 !== 0) continue;
    dues.push(day);
    if (!endDate && dues.length === 4) break;
  }
  const lastDue = dues[dues.length - 1];
  const weeks = lastDue ? Math.max(1, Math.ceil((calendarDayNumber(lastDue) - calendarDayNumber(startDate)) / 7)) : 0;
  const error = !dues.length ? 'No checkpoints fall on those weekdays before this end date. Choose another day or a later end date.'
    : dues.length > MAX_CHECKPOINTS ? 'This plan has ' + dues.length + ' checkpoints. Choose a shorter period or a slower pace (up to ' + MAX_CHECKPOINTS + ' checkpoints per unit).' : null;
  return { dues, weeks, error };
}
